import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class UpdateStaticFileGroupingExportFileSpecCommand extends ValueObject {

    public staticServiceProviderFileGroupingExportFileSpecId: number = 0;

    public staticServiceProviderFileGroupingId: number = 0;

    public staticExportFileSpecId: number = 0;

    public isExcluded: boolean = false;
}